import { render } from "./TimelineItem.vue?vue&type=template&id=3b8cbd3e"
import script from "./TimelineItem.vue?vue&type=script&lang=js"
export * from "./TimelineItem.vue?vue&type=script&lang=js"
script.render = render

export default script